import { isAbortedRequestNoise } from './isAbortedRequestNoise';
import { isCefSharpScannerNoise } from './isCefSharpScannerNoise';
import { isChunkLoadError } from './isChunkLoadError';
import { isDevToolingNoise } from './isDevToolingNoise';
import { isRecoverableReactDomNoise } from './isRecoverableReactDomNoise';
import { isResourceLoadNoise } from './isResourceLoadNoise';

/**
 * Errors that describe expected cancellation, HMR, stale chunks, or resource
 * loads rather than an application fault. Shared by Sentry `beforeSend` and
 * boundary reporting so the matchers cannot drift.
 */
export function isUnactionableClientNoise(error: unknown): boolean {
  return (
    isCefSharpScannerNoise(error) ||
    isRecoverableReactDomNoise(error) ||
    isDevToolingNoise(error) ||
    isAbortedRequestNoise(error) ||
    isChunkLoadError(error) ||
    isResourceLoadNoise(error)
  );
}
